module.exports = __webpack_public_path__ + "static/media/104.4682e19b.jpg";